import { render, staticRenderFns } from "./SubjectChip.vue?vue&type=template&id=1e3cbcb8&scoped=true"
import script from "./SubjectChip.vue?vue&type=script&lang=js"
export * from "./SubjectChip.vue?vue&type=script&lang=js"
import style0 from "./SubjectChip.vue?vue&type=style&index=0&id=1e3cbcb8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3cbcb8",
  null
  
)

export default component.exports